"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineColumns = defineColumns;
exports.defineSubFilter = defineSubFilter;
function defineColumns(columns) {
    return columns;
}
function defineSubFilter(subFilter) {
    return subFilter;
}
